<form [formGroup]="webFlowFormVal">
    <div class="form-group row">
        <div class="col-6">
            <label for="path" class="font-bold">Path <span class="text-danger">*</span></label>
            <input type="text" id="path" class="form-control form-control-sm" name="path" 
                formControlName="uri" [class.is-invalid]="submitted && f.uri.errors" [class.is-valid]="submitted && !f.uri.errors" [placeholder]="webFlowFormVal?.value?.environmentSpecific ? 'Example : /relay-api/endPoints/onboard/{{api}}/count' : 'Example : https://relay-stage.corp.adobe.com/#relay/endpoint/new'">
        </div>
        <div class="col-6">
            <label for="threshold" class="font-bold" [ngbTooltip]="constants.newEndpointThreshold">Threshold (in seconds)</label>
            <input type="number" id="threshold" min="0" name="threshold" class="form-control form-control-sm"
                placeholder="Threshold (in seconds)" formControlName="threshold">
        </div>
    </div>
    <div class="form-group row">
        <div class="col-4 mt-3" style="display:flex">
            <div style="width: 85%">
                <label for="environment-specific" class="font-bold">Environment specific</label> <a [routerLink]="['/user/environment-management']" target="_blank" *ngIf="webFlowFormVal.value?.environmentSpecific"><i class="fab fa-cloudversify ml-1 text-primary" title="Add/View Environment" style="font-size:large;"></i></a>
                <small id="envspecificYes" class="form-text text-muted" *ngIf="webFlowFormVal.value?.environmentSpecific">{{constants.newEndpointSpecificYes}}</small>
                <small id="envspecificNo" class="form-text text-muted" *ngIf="webFlowFormVal.value?.environmentSpecific === false">{{constants.newEndpointSpecificNo}}</small>
            </div>
            <ui-switch class="mt-4" size="small" id="environment-specific" checkedLabel="YES" uncheckedLabel="No"
                formControlName="environmentSpecific"></ui-switch>
        </div>
    </div>
</form>